import { render, staticRenderFns } from "./zhipai.vue?vue&type=template&id=5ca3f243&scoped=true&"
import script from "./zhipai.vue?vue&type=script&lang=js&"
export * from "./zhipai.vue?vue&type=script&lang=js&"
import style0 from "./zhipai.vue?vue&type=style&index=0&id=5ca3f243&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ca3f243",
  null
  
)

export default component.exports